import { render, staticRenderFns } from "./RegistrationAndLoginSupportError.vue?vue&type=template&id=01d306e0&scoped=true&"
var script = {}
import style0 from "./RegistrationAndLoginSupportError.vue?vue&type=style&index=0&id=01d306e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d306e0",
  null
  
)

export default component.exports